// extracted by mini-css-extract-plugin
export default {"container":"TilesPlateV2_container__LyIq8","masonry":"TilesPlateV2_masonry__9RnbK","masonryColumn":"TilesPlateV2_masonryColumn__SVNSu"};